import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getCommodities } from "../../../common/services/products/commodityService";
import SearchBox from "../../../common/components/search/searchBox";
import CommoditiesTable from "./commoditiesTable";
import { withTranslation } from "react-i18next";

class Commodities extends Component {
  constructor(props) {
    super(props);

    this.handleCommodityUpdated = this.handleCommodityUpdated.bind(this);
  }

  state = {
    commodities: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({ commodities: await getCommodities(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleToggleActiveOnly = () => {
    this.setState({ activeOnly: !this.state.activeOnly });
  };

  handleCommoditySelected = (commodity, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(commodity, this.handleCommodityUpdated, isNew);
  };

  handleCommodityUpdated = (commodity) => {
    const commodities = [...this.state.commodities];
    const index = commodities.findIndex(
      (u) => u.commodityId === commodity.commodityId
    );
    if (index > -1) {
      commodities.splice(index, 1);
    }
    commodities.push(commodity);
    this.setState({ commodities: commodities });
  };

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      commodities: allCommodities,
      activeOnly,
    } = this.state;

    let filtered = allCommodities;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.name != null &&
            u.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.shortName != null &&
            u.shortName.toLowerCase().includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, sortColumn, activeOnly, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: commodities } = this.getFilteredData();

    const newCommodity = {
      commodityId: uuid(),
      name: t("NewCommodity"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleCommoditySelected(newCommodity, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddCommodity")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedCommodity", { count: totalCount })}</p>
        <CommoditiesTable
          commodities={commodities}
          sortColumn={sortColumn}
          onSort={this.handleSort}
          onRowClick={this.handleCommoditySelected}
        />
      </div>
    );
  }
}

export default withTranslation(["products"])(Commodities);
